<template>
    <div class="container-fluid d-flex flex-column">
        <div id="print_label" class="card card-box p-4 ">
            <div class="d-flex flex-row flex-wrap justify-content-center printStart" style="gap: 10px">
                <div v-for="(item) in selectedObat" :key="item.id"
                    class="d-flex flex-column justify-content-center align-items-center">
                    <div class="printLabel">
                        <div class="p-4 bg-secondary  h-100">
                            <div class="mb-2">
                                <strong>{{ pasienInfo.nama }}</strong>
                                <p>{{ pasienInfo.tanggal_lahir }}</p>
                            </div>
                            <div>
                                <p class="mb-0">{{ pasienInfo.no_invoice }} {{ pasienInfo.tanggal_konsultasi }}</p>
                                <div>
                                    <p style="font-size: 14px;" class="mb-3">{{ item.nama_layanan }}</p>
                                    <span class="font-weight-bold">{{ item.aturan_pakai === null ? '-' : item.aturan_pakai
                                    }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
        <div class="d-flex mt-5 align-self-center" style="gap: 10px;">
            <b-button @click="closeViewCetakLabel" variant="danger" size="sm">Tutup</b-button>
            <b-button @click="printElement" variant="success" size="sm">Print</b-button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        pasienInfo: {
            type: Object,
            required: true
        },
        selectedObat: {
            type: Array
        }
    },

    methods: {
        printElement() {
            // Get the element to print
            const elementToPrint = document.getElementById('print_label');

            const pageStyle = `<style>
                            @media print {
                                    
                                    printStart {
                                        justify-content: start
                                    }
                                }
                                </style>`;

            // Get HTML to print from the element
            const prtHtml = elementToPrint.innerHTML;

            // Get all stylesheets HTML
            let stylesHtml = '';
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML;
            }

            // Open the print window
            const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

            WinPrint.document.write(`<!DOCTYPE html>
                        <html>
                        <head>
                            ${stylesHtml}
                           ${pageStyle}
                        </head>
                        <body>
                            ${prtHtml}
                        </body>
                        </html>`);

            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();
            WinPrint.close();
        },
        closeViewCetakLabel() {
            this.$emit('toggle')
        }
    },

}
</script>

<style lang="scss" scoped>
.printLabel {
    width: 330px;
    min-height: 200px;
}
</style>